import { render } from "./recuperarContraseña.vue?vue&type=template&id=5df9600f"
import script from "./recuperarContraseña.vue?vue&type=script&lang=js"
export * from "./recuperarContraseña.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__